import ReactDOMServer from "react-dom/server";

import { tooltipContainerConfig } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";

import { PieChartDetailedTooltip } from "app/pages/activation/components/Shared/ChartTableTooltip/ChartTableTooltip";

export const pieConfig = {
    chart: {
        height: 38,
        width: 38,
        animation: false,
        type: "pie",
        plotBackgroundColor: "transparent",
    },
    legend: {
        enabled: false,
    },
    tooltip: {
        enabled: true,
        followPointer: true,
        outside: true,
        headerFormat: ``,
        useHTML: true,
        ...tooltipContainerConfig().tooltip,
        pointFormatter() {
            return ReactDOMServer.renderToString(<PieChartDetailedTooltip data={this?.tooltipData} />);
        },
    },
    plotOptions: {
        pie: {
            center: [-10, -10],
            animation: false,
            showInLegend: true,
            cursor: "pointer",
            borderWidth: 0,
            innerSize: "68%",
            size: 36,
            borderRadius: 0,
            states: {
                hover: {
                    halo: null,
                },
            },
            dataLabels: {
                enabled: false,
            },
        },
        series: {
            enableMouseTracking: true,
        },
    },
};

export const defaultEmptyPieData = [
    {
        data: [
            {
                color: colorsPalettes.carbon[50],
                id: "Default",
                name: "N/A",
                isEmpty: true,
                total: 100,
                y: 100,
            },
        ],
    },
];
